import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import { nesdata } from "../../../Utils/Apis";

export const useCategories = () => {
  const [form, setForm] = useState({
    selected: {},
  });
  const { post, dispatch } = useMainContext();
  const [init, setInint] = useState({});
  const [loading, setLoading] = useState({ get: true });
  const { searchParams, changeObj, getValue } = useQuery({
    filters: [{ key: "category_id" }],
  });
  const navigate = useNavigate();

  const getCategory = async () => {
    setLoading({ get: true });
    const { data, status } = await post(nesdata, {
      needkey: ["categories"],
    });
    setInint(data);
    setLoading({ get: false });
  };
  useEffect(() => {
    getCategory();
  }, []);

  return {
    form,
    setForm,
    init,
    loading,
    searchParams,
    changeObj,
    dispatch,
    getValue,
    navigate,
  };
};
